let backendHost;

const hostname=window && window.location && window.location.hostname;
if(hostname === 'localhost'){
    backendHost = 'http://localhost:8084/';
}
else if(hostname === 'adex.iugo.tech'){
    backendHost = 'https://adex-api.iugo.tech/';
}
export const API_ROOT = `${backendHost}`;


// WEBPACK FOOTER //
// ./src/constants/api-config.jsx